

function TextsClass(){

  return {

    gettext: function(key) {

      return window.texts[key] ? window.texts[key] : key
    }
  }
}

const Texts = new TextsClass()

window.__ = Texts.gettext